<template>
  <button
    class="tw-p-4 tw-relative"
    :class="{ 'tw-font-bold': active }"
    @click="$emit('click')"
  >
    <p>{{ label }}</p>
    <span
      class="
        tw-absolute
        tw-bottom-0
        tw-left-0
        tw-right-0
        tw--mb-1
        tw-border-b-4
        tw-border-noraGray-600
      "
      :class="{ 'tw-hidden': !active }"
    ></span>
  </button>
</template>

<script>
export default {
  props: {
    active: {
      default: false,
      type: Boolean,
    },
    label: String,
  },
};
</script>

<style scoped></style>
